import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const Event = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="Financial Advisory & Investment Management Services" 
      subtitle="Comprehensive financial planning, portfolio management, and wealth advisory services tailored to individual and institutional clients, featuring advanced analytics, risk management, and strategic investment solutions across traditional and digital assets."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Professional Financial Advisory Services</h2>
            <p>
              We deliver customized financial advisory and investment management services designed to optimize client portfolios, enhance wealth preservation, and achieve long-term financial objectives through strategic planning, risk management, and comprehensive market analysis.
            </p>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Strategic Financial Planning & Wealth Management</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Comprehensive financial planning services designed to develop and implement strategic wealth management solutions, incorporating sophisticated analysis, goal-oriented planning, and customized investment strategies to achieve optimal financial outcomes.
                  </p>
                  
                  <div className="info-section">
                    <h4>Financial Planning & Goal Setting</h4>
                    <ul>
                      <li>Comprehensive financial needs analysis and goal identification</li>
                      <li>Strategic asset allocation planning and target setting</li>
                      <li>Cash flow analysis and liquidity management planning</li>
                      <li>Tax-efficient investment strategy development</li>
                      <li>Retirement planning and wealth accumulation strategies</li>
                      <li>Estate planning and wealth transfer optimization</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Wealth Preservation & Growth</h4>
                    <ul>
                      <li>Multi-generational wealth preservation strategies</li>
                      <li>Inflation protection and purchasing power maintenance</li>
                      <li>Currency hedging and international diversification</li>
                      <li>Alternative investment opportunity identification</li>
                      <li>Private wealth management for high-net-worth individuals</li>
                      <li>Family office advisory and governance structures</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Financial Planning Services" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Financial Planning Services')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Professional Portfolio Management & Investment Solutions</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Expert portfolio management services combining sophisticated quantitative analysis, market research, and strategic asset allocation to build diversified investment portfolios optimized for risk-adjusted returns and long-term capital appreciation.
                  </p>
                  
                  <div className="info-section">
                    <h4>Active Portfolio Management</h4>
                    <ul>
                      <li>Dynamic asset allocation and rebalancing strategies</li>
                      <li>Professional investment manager selection and due diligence</li>
                      <li>Direct equity and fixed income portfolio construction</li>
                      <li>Alternative investment integration (REITs, commodities, private equity)</li>
                      <li>ESG (Environmental, Social, Governance) investment integration</li>
                      <li>Tactical asset allocation adjustments based on market conditions</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Investment Strategy & Execution</h4>
                    <ul>
                      <li>Custom investment policy statement development</li>
                      <li>Benchmark selection and performance measurement</li>
                      <li>Cost-efficient portfolio implementation strategies</li>
                      <li>Tax-loss harvesting and tax-efficient investing</li>
                      <li>Dollar-cost averaging and systematic investment programs</li>
                      <li>Cross-border investment structuring and execution</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Portfolio Management" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Portfolio Management')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Advanced Analytics, Reporting & Risk Management</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Comprehensive investment analytics and risk management services utilizing advanced quantitative models, real-time monitoring, and detailed performance reporting to optimize portfolio outcomes and manage downside risks across all asset classes including traditional and digital assets.
                  </p>
                  
                  <div className="info-section">
                    <h4>Performance Analytics & Reporting</h4>
                    <ul>
                      <li>Consolidated multi-asset class performance reporting and attribution analysis</li>
                      <li>Real-time portfolio valuation and exposure monitoring across all holdings</li>
                      <li>Comprehensive benchmark analysis and peer comparison studies</li>
                      <li>Tax reporting and capital gains/loss analysis for optimization</li>
                      <li>ESG impact measurement and sustainability reporting</li>
                      <li>Digital asset integration including cryptocurrency portfolio tracking</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Quantitative Risk Management</h4>
                    <ul>
                      <li>Value-at-Risk (VaR) modeling and stress testing analysis</li>
                      <li>Portfolio correlation analysis and diversification optimization</li>
                      <li>Liquidity risk assessment and contingency planning</li>
                      <li>Currency exposure analysis and hedging strategy implementation</li>
                      <li>Systematic risk identification and mitigation protocols</li>
                      <li>Scenario analysis for market volatility and economic downturns</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Analytics and Risk Management" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Analytics and Risk Management')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="immigration-service-card">
            <div className="service-header">
              <h3>Why Choose Our Financial Advisory & Investment Management?</h3>
            </div>
            <div className="service-content">
              <div className="service-text">
                <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>
                  We deliver sophisticated financial advisory services combining institutional-grade investment management, advanced analytics, and personalized wealth planning to optimize long-term financial outcomes for discerning clients and institutions.
                </p>
                
                <div className="info-section">
                  <h4>Institutional-Grade Investment Management</h4>
                  <p>Professional portfolio management utilizing advanced quantitative models and institutional investment strategies.</p>
                </div>
                
                <div className="info-section">
                  <h4>Multi-Asset Class Expertise</h4>
                  <p>Comprehensive coverage across traditional assets, alternative investments, and digital currencies with global market access.</p>
                </div>
                
                <div className="info-section">
                  <h4>Advanced Risk Analytics</h4>
                  <p>Sophisticated risk management utilizing quantitative models, stress testing, and real-time monitoring for optimal outcomes.</p>
                </div>
                
                <div className="info-section">
                  <h4>Tax-Optimized Strategies</h4>
                  <p>Integration of tax-efficient investment strategies with comprehensive financial planning to maximize after-tax returns.</p>
                </div>
                
                <div style={{marginTop: '32px', padding: '24px', background: 'rgba(0,0,0,0.05)', borderRadius: '12px'}}>
                  <p style={{margin: '0', fontSize: '1rem', lineHeight: '1.6', fontStyle: 'italic'}}>
                    Our comprehensive financial advisory approach integrates strategic planning, professional portfolio management, and sophisticated analytics to deliver superior investment outcomes while preserving and growing wealth across multiple generations and market cycles.
                  </p>
                </div>
              </div>
              <div className="service-image">
                <img 
                  src="/images/why_chose_finance.png" 
                  alt="Financial Advisory Excellence" 
                  onClick={() => openLightbox('/images/why_chose_finance.png', 'Financial Advisory Excellence')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Optimize Your Financial Strategy</h3>
            <p>Ready to enhance your wealth management with professional advisory services? Contact our financial specialists for personalized consultation.</p>
            <a href="/contact" className="btn immigration-btn-primary">Schedule Financial Consultation</a>
          </div>
        </div>
      </section>
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default Event;